<div class="mt-5">
<div class="d-flex justify-content-center" *ngIf="provider && access_token && userId">
    <div class="card col-12 col-lg-5">
        <main class="form-signin">
            <form [formGroup]="registerForm" (ngSubmit)="register()" autocomplete="off">
                <div class="text-center mb-4">
                    <h3 class="mb-3 font-weight-normal">
                        Creating an account using your <span class="text-warning">{{provider | titlecase}}</span>
                    </h3>
                </div>
                <div class="form-floating mb-3">
                    <input formControlName="firstName" type="text" placeholder="First name" class="form-control"
                        [class.is-invalid]="submitted && registerForm.get('firstName')?.errors">
                    <label for="firstName">First name</label>
                    <span class="text-danger" *ngIf="submitted && registerForm.get('firstName')?.hasError('required')">
                        First name is required
                    </span>
                    <span class="text-danger"
                        *ngIf="submitted && 
                        registerForm.get('firstName')?.hasError('minlength') || registerForm.get('firstName')?.hasError('maxlength')">
                        First name must be at least 3, and maximum 15 characters
                    </span>
                </div>
                <div class="form-floating mb-3">
                    <input formControlName="lastName" type="text" placeholder="Last name" class="form-control"
                        [class.is-invalid]="submitted && registerForm.get('lastName')?.errors">
                    <label for="lastName">Last name</label>
                    <span class="text-danger" *ngIf="submitted && registerForm.get('lastName')?.hasError('required')">
                        Last name is required
                    </span>
                    <span class="text-danger"
                        *ngIf="submitted && 
                        registerForm.get('lastName')?.hasError('minlength') || registerForm.get('lastName')?.hasError('maxlength')">
                        Last name must be at least 3, and maximum 15 characters
                    </span>
                </div>

                <div class="form-floatin" *ngIf="errorMessages.length > 0">
                    <identity-validation-messages [errorMessages]="errorMessages"></identity-validation-messages>
                </div>

                <div class="d-grid mt-4 px-1">
                    <button class="btn btn-lg btn-info" type="submit">Create Account</button>
                </div>
            </form>
        </main>
    </div>
</div>
</div>